import MenuItemSelector from "./MenuItemSelector";

export type {
  MenuItemSelectorOption,
  MenuItemSelectorProps,
} from "./MenuItemSelector";

export default MenuItemSelector;
